// extracted by mini-css-extract-plugin
module.exports = {"form_wrapper":"form_wrapper--33k8n","form":"form--308GW","title":"title--25sF9","submit_btn":"submit_btn--s5_-O"};